import { render } from "./PlatformHandoff.vue?vue&type=template&id=4f27de5f"
import script from "./PlatformHandoff.vue?vue&type=script&lang=js"
export * from "./PlatformHandoff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__